"use client";
import s from "./BlogPagination.module.scss";
import ReactPaginate from "react-paginate";
import cn from "classnames";
// import { Icon } from "../../UI/Icon";

import { useRedirect } from "@/helpers/useRedirect";
import { usePathname, useSearchParams } from "next/navigation";
import { SpriteIcon } from "@/components/UI/SpriteIcon";

import IconAngleLeft from "public/img/icons/svg/angle-left.svg";
import IconAngleRight from "public/img/icons/svg/angle-right.svg";

export type BlogPaginationProps = {
  page: number;
  pageCount: number;
  type?: "server" | "client";
  controls?: {
    setPage: (value: number) => void;
    setPageCount?: (value: number) => void;
  };
};

export const BlogPagination = ({ page, pageCount, type = "server", controls }: BlogPaginationProps) => {
  const redirect = useRedirect();

  const pathname = usePathname();
  const searchParams = useSearchParams();

  const onPageChange = ({ selected }: { selected: number }) => {
    const selectedPage = selected + 1;
    if (type === "server") {
      const updatedParams = new URLSearchParams(searchParams);
      updatedParams.delete("page");

      if (selectedPage > 1) {
        updatedParams.set("page", `${selectedPage}`);
      }

      const paramsString = updatedParams.toString();

      redirect(
        selectedPage > 1
          ? pathname + "?" + paramsString
          : !!paramsString
          ? pathname + "?" + paramsString
          : pathname,
        true
      );
    }

    if (type === "client") {
      controls?.setPage(selectedPage);
    }
  };

  return (
    <ul className={s.wrapper}>
      <ReactPaginate
        breakLabel="..."
        onPageChange={onPageChange}
        pageRangeDisplayed={3}
        marginPagesDisplayed={1}
        forcePage={page - 1}
        pageCount={pageCount}
        nextLabel={<SpriteIcon icon={IconAngleRight} />}
        previousLabel={<SpriteIcon icon={IconAngleLeft} />}
        renderOnZeroPageCount={null}
        containerClassName={s.container}
        pageClassName={s.item}
        activeClassName={s.active}
        previousClassName={cn(s.button, s.previous)}
        nextClassName={cn(s.button, s.next)}
        disabledClassName={s.buttonDisabled}
      />
    </ul>
  );
};
